import React, { FC } from "react";
import { formatDate, formatText } from "../../Utils";
import { GalleryType } from "../../Structures";
import { Link } from "react-router-dom";

interface IProps {
  title: string;
  data: GalleryType[];
}

const LandingRecentlyItems: FC<IProps> = (props) => {
  // ==============================================================================================================

  return (
    <div className="container mb-3" data-sticky-container>
      <div className="row">
        <div className="col-lg-12">
          <div className="mb-3">
            <h2 className="m-0 fw-bold d-flex align-items-center">
              <i className="bi bi-hourglass-top me-2"></i>
              {props.title}
            </h2>
          </div>
          <div className="row gy-4">
            {props.data.map((item, index) => (
              <div key={index} className="col-sm-3">
                <div className="card">
                  <div className="position-relative">
                    <div
                      style={{ height: 190 }}
                      className="card-image w-100 position-relative"
                    >
                      <img
                        className="card-img w-100 h-100 object-fit-cover"
                        src={item.thumbnail}
                        alt={item.title}
                      />
                    </div>
                  </div>
                  <div className="card-body px-0 pt-3">
                    <h4 className="card-title">
                      <Link
                        to={`/gallery/${item.id}`}
                        className="btn-link text-reset truncate w-100 d-block"
                      >
                        {item.title}
                      </Link>
                    </h4> 
                    <p className="card-text">
                      {formatText(item.description, 100)}
                    </p>

                    <ul className="nav nav-divider align-items-center d-none d-sm-inline-block">
                      <li className="nav-item">
                        {formatDate(item.create_date)}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingRecentlyItems;
